import Cookies from 'js-cookie';

export type TokenType = {
  access_token: string | null;
  refresh_token: string | null;
  expires_in: string | null;
};
export const getTokenDetails = () => {
  return {
    access_token: Cookies.get('access_token'),
    refresh_token: Cookies.get('refresh_token'),
  };
};

export const storeToken = (refreshResult: { data: TokenType }) => {
  const data = refreshResult?.data;

  if (data.access_token) {
    Cookies.set('access_token', data.access_token);
  }
  if (data.refresh_token) {
    Cookies.set('refresh_token', data.refresh_token);
  }
};

export const clearToken = () => {
  Cookies.remove('access_token');
  Cookies.remove('refresh_token');
};
